
import { SvgIcon, SvgIconProps } from "designSystem/index";
import React, { FunctionComponent } from "react";

const XAxis3DIcon: FunctionComponent<SvgIconProps> = ({ ...props }) => {
	return (
		<SvgIcon {...props}>
			<svg
				fill="none"
				height="16"
				viewBox="0 0 18 16"
				width="18"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M8.40817 1.08326L8.15836 1.08148L8.1564 1.33129L8.08338 10.6542L8.08142 10.9044L8.3316 10.9062L9.79191 10.9166L10.0417 10.9184L10.0437 10.6685L10.1167 1.34559L10.1187 1.09542L9.86848 1.09364L8.40817 1.08326Z"
					fill="#C3C9D4"
					stroke="#C3C9D4"
					strokeWidth="0.5"
				/>
				<path
					d="M8.46992 9.20466L8.34472 8.99593L8.13272 9.1155L0.877186 13.2077L0.653528 13.3338L0.785609 13.554L1.53008 14.7952L1.65528 15.0039L1.86728 14.8843L9.12281 10.7922L9.34647 10.666L9.21439 10.4458L8.46992 9.20466Z"
					fill="#C3C9D4"
					stroke="#C3C9D4"
					strokeWidth="0.5"
				/>
				<path
					d="M9.59231 9.11591L9.33399 8.9807L9.23978 9.25662L8.76341 10.6518L8.69414 10.8546L8.88406 10.954L16.4077 14.8922L16.666 15.0274L16.7602 14.7515L17.2366 13.3564L17.3059 13.1535L17.1159 13.0541L9.59231 9.11591Z"
					fill="#E75E4F"
					stroke="#E75E4F"
					strokeWidth="0.5"
				/>
			</svg>
		</SvgIcon>
	);
};

export default XAxis3DIcon;